const TestimonialData = [
  {
    avatar: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "John Anderson",
    review:
      "Impressed with TZ Creation's UX/UI design. They've improved our user experience. Their attention to detail and creativity are commendable.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    name: "Emily Turner",
    review:
      "TZ Creation's e-commerce setup exceeded expectations. User-friendly platform! They ensured every aspect was user-centric, resulting in a seamless experience.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/3.jpg",
    name: "David Martinez",
    review:
      "Our traffic grew significantly with TZ Creation's marketing strategies. They're experts at increasing brand visibility and engagement.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/4.jpg",
    name: "Lisa Smith",
    review:
      "TZ Creation's SEO expertise boosted our website's ranking. Their commitment to staying updated with the latest SEO trends is impressive.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/5.jpg",
    name: "Michael Davis",
    review:
      "Great results from TZ Creation's custom software. Their solutions are not only efficient but also highly tailored to our needs.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/6.jpg",
    name: "Jessica Robinson",
    review:
      "Superb graphic design by TZ Creation. Highly recommended! Their designs have made our brand stand out in a crowded market.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/7.jpg",
    name: "Alex Harris",
    review:
      "Efficient web development by TZ Creation. Impressive results. Their development team is quick to adapt to changes and deliver quality work.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/8.jpg",
    name: "Maria Lopez",
    review:
      "TZ Creation's attention to detail is commendable. Top-notch work! They leave no stone unturned in ensuring perfection.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/9.jpg",
    name: "Daniel Clark",
    review:
      "Our business saw remarkable growth with TZ Creation's digital marketing. Their strategies are not just effective but also data-driven.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/10.jpg",
    name: "Laura Taylor",
    review:
      "TZ Creation's UI/UX design improved our user engagement. They created a user-friendly interface that's a joy to interact with.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/11.jpg",
    name: "Kevin Adams",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/12.jpg",
    name: "Susan White",
    review:
      "Impressed with TZ Creation's web design and development. Their websites are not just visually appealing but also highly functional.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/13.jpg",
    name: "Richard Moore",
    review:
      "TZ Creation's SEO efforts are highly effective. They've managed to drive organic traffic like no other.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/14.jpg",
    name: "Amanda Parker",
    review:
      "Our brand's online presence improved significantly with TZ Creation. Their innovative digital marketing strategies have been a game-changer.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/15.jpg",
    name: "Chris Green",
    review:
      "TZ Creation's custom software has streamlined our workflow. It's tailored precisely to our needs, improving productivity.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/16.jpg",
    name: "Jessica Turner",
    review:
      "TZ Creation's graphic design work is not just creative but also highly effective. It resonates with our audience.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/17.jpg",
    name: "Daniel Harris",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/18.jpg",
    name: "Sarah Robinson",
    review:
      "Impressed with TZ Creation's marketing strategies. Their campaigns have brought us substantial ROI.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/19.jpg",
    name: "Emily Martinez",
    review:
      "Great results from TZ Creation's digital marketing. Their strategies have positioned our brand as a market leader.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/20.jpg",
    name: "Michael Davis",
    review:
      "TZ Creation's e-commerce setup is superb! Their attention to detail and user experience is evident in every aspect.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/21.jpg",
    name: "Lisa Smith",
    review:
      "Our site's traffic soared with TZ Creation's marketing. They've helped us connect with our target audience. Their expertise is unmatched.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/22.jpg",
    name: "John Anderson",
    review:
      "TZ Creation's SEO expertise is impressive. Our website now ranks prominently in search results, thanks to their efforts.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/23.jpg",
    name: "David Martinez",
    review:
      "TZ Creation's custom software is a game-changer. It's tailored precisely to our requirements, improving efficiency across the board.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/24.jpg",
    name: "Jessica Turner",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/25.jpg",

    name: "Daniel Harris",
    review:
      "Impressed with TZ Creation's marketing strategies. They've brought us substantial returns on our investment.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/26.jpg",
    name: "Michael Davis",
    review:
      "TZ Creation's e-commerce setup is superb! Their attention to detail and user experience is evident in every aspect.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/27.jpg",
    name: "Lisa Smith",
    review:
      "Our site's traffic soared with TZ Creation's marketing. They've helped us connect with our target audience. Their expertise is unmatched.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/28.jpg",
    name: "John Anderson",
    review:
      "TZ Creation's SEO expertise is impressive. Our website now ranks prominently in search results, thanks to their efforts.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/29.jpg",
    name: "David Martinez",
    review:
      "TZ Creation's custom software is a game-changer. It's tailored precisely to our requirements, improving efficiency across the board.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/30.jpg",
    name: "Jessica Turner",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/31.jpg",
    name: "Susan White",
    review:
      "Impressed with TZ Creation's web design and development. Their websites are not just visually appealing but also highly functional.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/32.jpg",
    name: "Richard Moore",
    review:
      "TZ Creation's SEO efforts are highly effective. They've managed to drive organic traffic like no other.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/33.jpg",
    name: "Amanda Parker",
    review:
      "Our brand's online presence improved significantly with TZ Creation. Their innovative digital marketing strategies have been a game-changer.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/34.jpg",
    name: "Chris Green",
    review:
      "TZ Creation's custom software has streamlined our workflow. It's tailored precisely to our needs, improving productivity.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/35.jpg",
    name: "Jessica Turner",
    review:
      "TZ Creation's graphic design work is not just creative but also highly effective. It resonates with our audience.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/36.jpg",
    name: "Daniel Harris",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/37.jpg",
    name: "Sarah Robinson",
    review:
      "Impressed with TZ Creation's marketing strategies. Their campaigns have brought us substantial ROI.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/38.jpg",
    name: "Emily Martinez",
    review:
      "Great results from TZ Creation's digital marketing. Their strategies have positioned our brand as a market leader.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/39.jpg",
    name: "Michael Davis",
    review:
      "TZ Creation's e-commerce setup is superb! Their attention to detail and user experience is evident in every aspect.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/40.jpg",
    name: "Lisa Smith",
    review:
      "Our site's traffic soared with TZ Creation's marketing. They've helped us connect with our target audience. Their expertise is unmatched.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/41.jpg",
    name: "John Anderson",
    review:
      "TZ Creation's SEO expertise is impressive. Our website now ranks prominently in search results, thanks to their efforts.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/42.jpg",
    name: "David Martinez",
    review:
      "TZ Creation's custom software is a game-changer. It's tailored precisely to our requirements, improving efficiency across the board.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/43.jpg",
    name: "Jessica Turner",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    name: "Daniel Harris",
    review:
      "Impressed with TZ Creation's marketing strategies. They've brought us substantial returns on our investment.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/45.jpg",
    name: "Michael Davis",
    review:
      "TZ Creation's e-commerce setup is superb! Their attention to detail and user experience is evident in every aspect.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/46.jpg",
    name: "Lisa Smith",
    review:
      "Our site's traffic soared with TZ Creation's marketing. They've helped us connect with our target audience. Their expertise is unmatched.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/47.jpg",
    name: "John Anderson",
    review:
      "TZ Creation's SEO expertise is impressive. Our website now ranks prominently in search results, thanks to their efforts.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/48.jpg",
    name: "David Martinez",
    review:
      "TZ Creation's custom software is a game-changer. It's tailored precisely to our requirements, improving efficiency across the board.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/49.jpg",
    name: "Jessica Turner",
    review:
      "Efficient web development by TZ Creation. Their attention to detail ensures a bug-free and responsive website.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/50.jpg",
    name: "Susan White",
    review:
      "Impressed with TZ Creation's web design and development. Their websites are not just visually appealing but also highly functional.",
  },
];

export default TestimonialData;
